(() => {
  const blog = document.querySelector('[data-uc-blog]');
  if (blog) {
    const buttons = [...blog.querySelectorAll('[data-filter]')];
    const cards = [...blog.querySelectorAll('[data-blog-card]')];
    const featured = blog.querySelector('[data-blog-featured]');
    const search = blog.querySelector('[data-blog-search]');
    const count = blog.querySelector('[data-blog-count]');
    const empty = blog.querySelector('[data-blog-empty]');
    let activeFilter = 'all';

    const applyFilters = () => {
      const query = (search?.value || '').trim().toLowerCase();
      let visibleGridCards = 0;
      cards.forEach((card) => {
        const matchesCategory = activeFilter === 'all' || card.dataset.category === activeFilter;
        const matchesSearch = !query || card.dataset.search.includes(query);
        const visible = matchesCategory && matchesSearch;
        card.hidden = !visible;
        if (visible && !card.closest('[data-blog-featured]')) visibleGridCards += 1;
      });
      const featuredCard = featured?.querySelector('[data-blog-card]');
      if (featured) featured.hidden = Boolean(featuredCard?.hidden);
      if (count) count.textContent = `${visibleGridCards} ${visibleGridCards === 1 ? 'story' : 'stories'}`;
      if (empty) empty.hidden = cards.some((card) => !card.hidden);
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      activeFilter = button.dataset.filter;
      buttons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      applyFilters();
    }));
    search?.addEventListener('input', applyFilters);
  }

  const article = document.querySelector('[data-uc-native-article]');
  if (!article) return;

  const content = article.querySelector('[data-article-content]');
  const toc = article.querySelector('[data-article-toc]');
  const tocList = article.querySelector('[data-article-toc-list]');
  const headings = [...(content?.querySelectorAll('h2, h3') || [])];
  const seenIds = new Set();

  const slugify = (text) => text.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || 'section';
  headings.forEach((heading, index) => {
    let id = heading.id || slugify(heading.textContent);
    while (seenIds.has(id)) id = `${id}-${index + 1}`;
    seenIds.add(id);
    heading.id = id;
  });

  if (toc && tocList && headings.length >= 3) {
    headings.filter((heading) => heading.tagName === 'H2').forEach((heading) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      tocList.appendChild(item);
    });
    toc.hidden = false;

    const links = [...tocList.querySelectorAll('a')];
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
      });
    }, { rootMargin: '-18% 0px -72% 0px' });
    headings.filter((heading) => heading.tagName === 'H2').forEach((heading) => observer.observe(heading));
  }

  const progress = document.querySelector('[data-reading-progress]');
  const updateProgress = () => {
    if (!progress) return;
    const start = article.offsetTop;
    const distance = Math.max(article.offsetHeight - window.innerHeight, 1);
    const percentage = Math.min(100, Math.max(0, ((window.scrollY - start) / distance) * 100));
    progress.style.width = `${percentage}%`;
  };
  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);

  document.querySelector('[data-copy-article]')?.addEventListener('click', async (event) => {
    const button = event.currentTarget;
    try {
      await navigator.clipboard.writeText(button.dataset.url || window.location.href);
      const original = button.textContent;
      button.textContent = 'Copied!';
      window.setTimeout(() => { button.textContent = original; }, 1600);
    } catch {
      window.prompt('Copy this link:', button.dataset.url || window.location.href);
    }
  });
})();
